import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { thirdparty } from "../..";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import RadioGroupFunctional from "../RadioGroupFunctional";
import "./emergency.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { error } from "jquery";

import "react-datepicker/dist/react-datepicker.css";

const HomeSampleCollection = () => {
    const [enableBtn, setEnableBtn] = useState(true);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        first_name: "",
        phone_number: "",
        email: "",
        address: "",
        message: "",
        user_file: "",
    });

    useEffect(() => {
        console.log("form data", formData);
        if (
            formData.first_name &&
            formData.phone_number &&
            formData.email &&
            formData.address &&
            formData.message
        ) {
            setEnableBtn(false);
        } else {
            setEnableBtn(true);
        }
    }, [
        formData
    ]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        // Check if a file was selected
        if (file) {
            // Update the formData state by setting the author_profile_pic to the selected file
            setFormData({
                ...formData,
                user_file: file,
            });
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await thirdparty.post("/home_sample_collections", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 201) {
                toast.success(
                    "Your request is received, you will be notified soon!"
                );
                setLoading(false);
            } else {
                toast.error("Ops something went wrong!");
                setLoading(false);
            }

            console.log("Form data sent:", response.status);
        } catch (error) {
            console.error("Error submitting form:", error);
            // Handle errors, show error messages, etc.
        }
    };

    return (
        <div>
            <SEO
                title="Home Sample Collection | Best Hospital in Bangladesh | United Hospital"
                description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
                pathSlug="/"
                keywords="Home Sample Collection "
            />
            <Helmet>
                <meta
                    name="description"
                    content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
                />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "LocalBusiness",
                        name: "United Hospital Limited",
                        image:
                            "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
                        telephone: "10666",
                        email: "info@uhlbd.com",
                        address: {
                            "@type": "PostalAddress",
                            streetAddress: "plot 15, Road 71, Gulshan",
                            addressLocality: "Dhaka",
                            addressRegion: "Dhaka",
                            addressCountry: "Bangladesh",
                            postalCode: "1212",
                        },
                        openingHoursSpecification: {
                            "@type": "OpeningHoursSpecification",
                            opens:
                                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
                        },
                        url: "http://www.uhlbd.com/",
                        aggregateRating: {
                            "@type": "AggregateRating",
                            ratingValue: "3.9",
                            bestRating: "5",
                            worstRating: "1",
                            ratingCount: "756",
                        },
                        review: {
                            "@type": "Review",
                            author: {
                                "@type": "Person",
                                name: "abdul kahar",
                            },
                            datePublished: "2019-02-12",
                            reviewRating: {
                                "@type": "Rating",
                                ratingValue: "3.9",
                                bestRating: "5",
                                worstRating: "1",
                            },
                            reviewBody:
                                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
                        },
                    })}
                </script>
                <meta
                    name="Subject"
                    content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
                />
                <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
                <meta name="Googlebot" content="all" />
                <meta http-equiv="imagetoolbar" content="no" />
                <meta name="robots" content="index, follow" />
                <meta name="copyright" content="Copyright &copy; uhlbd.com" />
                <meta name="owner" content="United Hospital" />
                <meta name="author" content="dcastalia.com" />
                <meta name="Rating" content="General" />
                <meta name="distribution" content="Global" />
                <meta
                    name="classification"
                    content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
                />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta
                    names="apple-mobile-web-app-status-bar-style"
                    content="black-translucent"
                />
                <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
            </Helmet>
            <Route component={Header} />
            <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
                <section className="banner-hero">
                    <img
                        src="/static/media/banner-profile.f160a4c1.jpg"
                        alt="banner-profile"
                        className="w-100"
                    />
                </section>
                <section className="prof-dr py-5">
                    <div className="container">
                        <div className="box-of-about border-part py-4">
                            <div className="container">
                                <div className="row gy-4">
                                    <div className="col-md-12">
                                        <h3
                                            className="text-center mb-5"
                                            style={{
                                                color: "#0C807D",
                                                fontWeight: "700",
                                            }}
                                        >
                                            Request for Home Sample Collection
                                        </h3>
                                    </div>
                                    <div className="col-md-12">
                                        <form action="" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="first_name">Name: *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="first_name"
                                                        name="first_name"
                                                        value={formData.first_name}
                                                        placeholder="Your full name"
                                                        required
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, first_name: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="phone_number">Phone: *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="phone_number"
                                                        name="phone_number"
                                                        value={formData.phone_number}
                                                        placeholder="Your phone number"
                                                        required
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, phone_number: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="email">Email: *</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="email"
                                                        name="email"
                                                        placeholder="Your email address"
                                                        value={formData.email}
                                                        required
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, email: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="form-group col-md-6">
                                                    <label htmlFor="address">Address: *</label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        id="address"
                                                        name="address"
                                                        value={formData.address}
                                                        required
                                                        placeholder="House No, Road No, Area, City, Country"
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, address: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="message">Message:</label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        id="message"
                                                        name="message"
                                                        value={formData.message}
                                                        placeholder="write your message here"
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, message: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-md-12">
                                                    <label htmlFor="Email">Prescription / File Upload:</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="user_file"
                                                        id="user_file"
                                                        onChange={handleFileChange}
                                                        accept="image/*" // Specify the accepted file types if needed
                                                    />
                                                </div>
                                            </div>
                                            <button
                                                className="buts"
                                                type="submit"
                                                disabled={enableBtn}
                                            >
                                                Submit
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Route component={Footer} />
            <ToastContainer autoClose={5000} />
        </div>
    )
}

export default HomeSampleCollection


// WEBPACK FOOTER //
// ./src/component/frontend/HomeSampleCollection.js